module.exports = __webpack_public_path__ + "static/media/Team 12 - Herotech.e62d1380.png";